import { ReactNode } from 'react';
import { TableSortLabel } from '@mui/material';
import type { ListSort, SortOrder } from '@/utils/listSort';

interface SortLabelProps {
  /** The API column (`sortBy`). */
  column: string;
  label: ReactNode;
  sort: ListSort;
  /** Direction of the first click (see `nextSort`). */
  firstOrder?: SortOrder;
  onSort: (column: string, firstOrder: SortOrder) => void;
}

/** A clickable column header that shows the list's current sort. */
const SortLabel = ({
  column,
  label,
  sort,
  firstOrder = 'asc',
  onSort
}: SortLabelProps) => {
  const active = sort.sortBy === column;
  return (
    <TableSortLabel
      active={active}
      direction={active ? (sort.sortOrder ?? firstOrder) : firstOrder}
      onClick={() => onSort(column, firstOrder)}
    >
      {label}
    </TableSortLabel>
  );
};

export default SortLabel;
